import React from 'react'
import { Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedExceptionBankFailureFraudProps {
  data: any
}

export default function RelatedExceptionBankFailureFraud({ data }: RelatedExceptionBankFailureFraudProps) {
  const theme = useTheme()
  const rows = [
    {
      label: '银行失联欺诈标记',
      flag: data?.aals_00001,
    },
  ]

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        关联人银行失联欺诈
      </Text>
      <div className="mt-3">
        <Table highlightOnHover withColumnBorders={false} verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>检查项目</Table.Th>
              <Table.Th>结果</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.label}>
                <Table.Td>{row.label}</Table.Td>
                <Table.Td
                  style={{
                    color: row.flag === 1 ? theme.warningColor : theme.primaryColor,
                    fontWeight: row.flag === 1 ? 600 : 500,
                  }}
                >
                  {row.flag === 1 ? '有' : '无'}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  )
}
